import { render, staticRenderFns } from "./activeblacklist.vue?vue&type=template&id=4d6950f8"
import script from "./activeblacklist.vue?vue&type=script&lang=js"
export * from "./activeblacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports